export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-safari-4.6fef19b4.svg";